/*eslint-disable */
import React, { useEffect } from 'react';

import { Card, Link, Box, Typography, Avatar, CardContent } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { LoadingButton } from '@mui/lab';
import { months, days } from '../../_mock';
import { isTenMinutesRemainingOrTimePassed } from '../../utils';

const StyledTitle = styled(Link)({
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const UpcomingEventsCard = ({
  item,
  setInvitePayload,
  isLoadingCredentials,
  setCancelId,
  isCancellingMeeting,
  cancelId,
  inviteId,
  // setParticipantId,
}) => {


  const fullName = `${item?.fname || ''} ${item?.lname || ''}`.trim();

  return (
    <Card
      sx={{
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Avatar and Name Section */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
          <Avatar
            src={item?.image ? `${item.image}?${Date.now()}` : undefined}
            alt={fullName}
            sx={{
              width: 60,
              height: 60,
              border: '2px solid',
              borderColor: 'divider',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
              flexShrink: 0,
            }}
          >
            {!item?.image && fullName.charAt(0).toUpperCase()}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <StyledTitle
              color="inherit"
              variant="h6"
              underline="hover"
              sx={{
                fontWeight: 500,
                lineHeight: 1.4,
                display: 'block',
                mb: 0.5,
              }}
            >
              {fullName}
            </StyledTitle>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
              <Box component="img" src="/assets/icons/emailIcon.svg" sx={{ width: 16, height: 16 }} />
              <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600 }}>
                {item?.email}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Date and Time Section */}
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              fontSize: '0.75rem',
              color: 'text.primary',
              mb: 1.5,
            }}
          >
            {`${new Date(item?.scheduleTime)?.getDate()} ${months[new Date(item?.scheduleTime)?.getMonth()]} ${new Date(
              item?.scheduleTime
            )?.getFullYear()} ${days[new Date(item?.scheduleTime)?.getDay()]} ${new Date(item?.scheduleTime)
              .toLocaleTimeString()
              .replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, '$1$3')}`}
          </Typography>

          {/* Info Section */}
          <Box sx={{ display: 'flex', gap: 0.5, mb: 2 }}>
            <Box component="img" src="/infoIcon.svg" sx={{ height: 20, width: 20, flexShrink: 0, mt: 0.25 }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: '0.6875rem',
                fontWeight: 400,
                color: 'text.secondary',
                lineHeight: 1.4,
              }}
            >
              The join button will be enabled on time and will stay enabled for an hour. By default all meetings are set
              for an hour.
            </Typography>
          </Box>
        </Box>

        {/* Action Buttons Section */}
        <Box sx={{ display: 'flex', gap: 1.5, mt: 'auto' }}>
          <LoadingButton
            variant="contained"
            color="success"
            onClick={() => {
              setInvitePayload(item);
              localStorage.setItem("MeetingParticipantInfo", JSON.stringify(item));
            }}
            loading={isLoadingCredentials && inviteId._id === item._id}
            sx={{ flex: 1 }}
          >
            Join Meeting
          </LoadingButton>
          <LoadingButton
            disabled={
              isTenMinutesRemainingOrTimePassed(item?.scheduleTime) ||
              isTenMinutesRemainingOrTimePassed(item?.scheduleTime, true)
            }
            variant="contained"
            color="error"
            onClick={() => setCancelId(item._id)}
            loading={isCancellingMeeting && cancelId === item._id}
            sx={{ flex: 1 }}
          >
            Cancel Meeting
          </LoadingButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UpcomingEventsCard;
